import classNames from 'classnames';
import React from 'react';

import { formatAccountNumber, getTruncatedNameWithSuffix } from '@eika-infrastruktur/format';
import { IconTypes } from '@eika/icon';
import { AttentionLabel, Label } from '@eika/label';

import useTranslation from '../../hooks/useTranslation';
import { FormattedPaymentItem } from './formatPaymentItems';

type Props = {
    payment: FormattedPaymentItem;
    hideLabel?: boolean;
};

const PaymentListItemContent: React.FC<Props> = ({ payment, hideLabel = false }) => {
    const translated = useTranslation();
    const hasOwner = payment.owner && !payment.owner.equalToUserLoggedOn;
    const description =
        payment.fromAccount?.alias ??
        formatAccountNumber(payment.fromAccount?.accountNumber) ??
        payment.fromAccount?.iban;
    return (
        <div
            className={classNames('future-payments-list-month__row', {
                'future-payments-list-month__row--has-label': hasOwner || payment.label,
            })}
        >
            {(hasOwner || payment.label) && !hideLabel && (
                <span className={classNames('future-payments-list-month__owner-label')}>
                    {hasOwner && (
                        <Label
                            type="info"
                            size="small"
                            icon={IconTypes.PROFIL_24}
                            text={getTruncatedNameWithSuffix(payment.owner?.name, translated.futurePaymentOwnerSuffix)}
                        />
                    )}
                    {payment.label && (
                        <AttentionLabel size="small" icon={IconTypes.UTROPSTEGN_24} text={payment.label} />
                    )}
                </span>
            )}

            <span className="future-payments-list-month__date">{payment.dueDateFormatted}</span>
            <span className="payment-description__text">{description}</span>
            <span className="future-payments-list-month__amount">{payment.amountFormatted}</span>
            <span className="future-payments-list-month__payment-type">
                {translated.futurePaymentType[payment.paymentItem.paymentItemType ?? 'UNKNOWN']}
            </span>
            {payment.fromAccount?.alias && payment.fromAccount?.alias !== description && (
                <span className="future-payments-list-month__from-account">{payment.fromAccount.alias}</span>
            )}
        </div>
    );
};

export default PaymentListItemContent;
